export default __webpack_public_path__ + "static/media/stadium.059b6822.jpg";